<template>
  <qx-card title="列表">
    <section class="tablePage">
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'route'">
                <span>{{
                  scope.row.sourceRegionName + '-' + scope.row.desRegionName
                }}</span>
              </section>
              <section v-if="scope.column.property === 'orderId'">
                <span class="primary cur" @click="orderDetail(scope.row)">{{
                  scope.row.orderId
                }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import {
  getTrailerUsedList,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'route',
            label: '线路',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'carDriverMan',
            label: '司机姓名',
          },
          {
            prop: 'carDriverPhone',
            label: '司机姓名',
          },
          {
            prop: 'dependTime',
            label: '时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getTrailerUsedList,
    orderDetail (item) {
      console.log(item);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
